import { computed } from '@ember/object';
import { isPresent } from '@ember/utils';
import { notEmpty, or, gt } from '@ember/object/computed';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import MoneyProto from '@square/dashboard-data/models/squareup/common/money-proto';
import SquareProcessingFeeAmountDetails from '@square/dashboard-data/models/squareup/beemo/api/v2/models/square-processing-fee-amount-details';
import ThirdPartyFeeAmountDetail from '@square/dashboard-data/models/squareup/beemo/api/v2/models/third-party-fee-amount-detail';
export default ProtoBaseModel.extend({
  squareProcessingFeeMoney: attr(MoneyProto),
  taxOnProcessingFeeMoney: attr(MoneyProto),
  squareProcessingFeeAmountDetails: attr(SquareProcessingFeeAmountDetails),
  // to be deprecated
  squareProcessingFeeAmountDetailList: repeated(SquareProcessingFeeAmountDetails),
  thirdPartyFeeAmountDetails: repeated(ThirdPartyFeeAmountDetail),
  taxPercentageOfSquareFees: computed('squareProcessingFeeMoney.amount', 'taxOnProcessingFeeMoney.amount', function () {
    return this.taxOnProcessingFeeMoney.amount / this.squareProcessingFeeMoney.amount * 100;
  }),
  squareProcessingFeeWithTax: computed('squareProcessingFeeMoney', 'taxOnProcessingFeeMoney', function () {
    const total = this.squareProcessingFeeMoney;
    if (this.taxOnProcessingFeeMoney) {
      return total.add(this.taxOnProcessingFeeMoney);
    }
    return total;
  }),
  hasThirdPartyFeeAmountDetails: notEmpty('thirdPartyFeeAmountDetails'),
  hasAdditionalFeeDetails: or('hasThirdPartyFeeAmountDetails', 'squareProcessingFeeAmountDetails.isCostPlus'),
  hasSquareProcessingFeeAmountDetailList: gt('squareProcessingFeeAmountDetailList.length', 0),
  feeAmountDetails: computed('hasSquareProcessingFeeAmountDetailList', 'squareProcessingFeeAmountDetails', 'squareProcessingFeeAmountDetailList', function () {
    // TODO: remove when squareProcessingFeeAmountDetails fully deprecated
    // Use squareProcessingFeeAmountDetailList if populated, otherwise refer to original squareProcessingFeeAmountDetails
    if (this.hasSquareProcessingFeeAmountDetailList) {
      return this.squareProcessingFeeAmountDetailList.compact();
    }
    if (isPresent(this.squareProcessingFeeAmountDetails)) {
      return [this.squareProcessingFeeAmountDetails];
    }
    return [];
  })
});